import { Injectable, Output, EventEmitter } from '@angular/core';
import { SolarService } from './solarservice.service';
import { Site } from 'solar-bo';;
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorcontrolService } from 'basecomponents';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { AppConfig } from '@solar/app.config';
import { tap, catchError, map } from 'rxjs/operators';
import { SortHelper } from 'shtools';
import { IDbFilters } from '../dashboard/db-filter/db-filter.component';
import { DbFilter } from '../dashboard/db-overview/db-filter-helper';
import { IDB_filter, IDB_api_filter, IDB_Chart_Res } from 'solar-bo';import { IFilterItemCollection } from '../dashboard/db-filter/filter';
;


@Injectable({
  providedIn: "root"
})
export class DashboardService {

  private apiurlbase = AppConfig.API_ENDPOINT + '';  // URL to web api
  //sitesAll: Site[] = [];

  get sitesAll() {
    return this.solarService.sites;
  }

  @Output() siteListChange = new EventEmitter<any>(true);
  @Output() errorEvent = new EventEmitter<any>();

  dbFilterGlobal: DbFilter = new DbFilter();

  constructor(private http: HttpClient
    , private solarService: SolarService
    , private errorcontrolservice: ErrorcontrolService) {

    this.getSiteList();
  }

  getSiteList(): Observable<Site[]> {
    if (this.sitesAll && this.sitesAll.length > 0) {
      console.log("DashboardService retrieving cached sites")
      return of(this.sitesAll);
    }

    let res = this.solarService.sitesGetAll()
      .pipe(
        tap(reslist => {
          console.log("DashboardService retrieving sites end");
          return this.sitesAll;
        })
      );
    return res;
  }


  result: any;
  resultsGetBySupervisionId(id): Observable<any[]> {
    const url = `${this.apiurlbase}/supervisions/${id}/results`;
    return this.http.get<any[]>(url, AppConfig.httpOptions)
      .pipe(
        tap(result => this.saveResult(result)),
        catchError(this.errorcontrolservice.handleError('resultsGetByFilter', []))
      );
  }

  saveResult(result) {
    this.result = result;
    //this.dbFilterGlobal.sitesSetOriginal(this.sitesAll);
  }

  //no usado
  filterGetColumnFilters(filters: IDbFilters) {
    //seria llamar al servicio y retornaria los items de cada columna a mostrar
    let lst = this.result.slice();
    if (filters.issuetype.length > 0) {
      lst = lst.filter(item => item.issue_type in filters.issuetype);
    }

    return lst;
  }


  resultFilteredGetByFilter(filters: IDbFilters): any[] {
    let lst = this.result.slice();

    //todo:filtramos por nombre ya que es lo que hay en el dataset de resultados
    let sitenames = filters.sites.map(function (item, index, array) {
      return item.name;
    });

    if (filters.sites.length > 0) {
      lst = lst.filter(item => sitenames.includes(item.site_name));
    }
    if (filters.issuetype.length > 0) {
      lst = lst.filter(item => filters.issuetype.includes(item.issue_type));
    }
    if (filters.relevance.length > 0) {
      lst = lst.filter(item => filters.relevance.includes(item.relevance));
    }
    if (filters.moduletypes.length > 0) {
      lst = lst.filter(item => filters.moduletypes.includes(item.panel_model));
    }

    return lst;

  }


  supervisionGetResults(id: string): Observable<any[]> {
    return this.solarService.supervisionGetResults(id);
  }

  db_siteResultsFilterByCount(id_supervision: string, groupby: string, filterList?: IFilterItemCollection[]): Observable<any[]> {
    let columns = [];
    columns.push(groupby);
    columns.push("count(" + groupby + ") as count");
    return this.db_siteResultsFilterBy(id_supervision, columns, groupby, filterList);
  }

  db_siteResultsFilterBy(id_supervision: string, columns: any[], groupby: string, filterList?: IFilterItemCollection[]): Observable<any[]> {
    let f = {} as any;
    f.columns = columns;
    f.groupby = groupby;
    this.configFilter(f, filterList);

    let filterJson = JSON.stringify(f);
    //console.log("db_resultsFilterBy filterJson: ", filterJson);

    let url = `${this.apiurlbase}/supervisions/${id_supervision}/results`;
    return this.http.post<IDB_Chart_Res[]>(url, filterJson, AppConfig.httpOptions).pipe(
      //tap(result => console.log("db_resultsFilterBy", result)),
      map(res => this.convertResultToNumber(res)),
      catchError(this.errorcontrolservice.handleError<any>('db_resultsFilterBy'))
    );
  }


  db_resultsFilterByCount(groupby: string, filterList?: IFilterItemCollection[], lastSupervision = true): Observable<any[]> {
    let columns = [];
    columns.push(groupby);
    columns.push("count(" + groupby + ") as count");
    return this.db_resultsFilterBy(columns, groupby, filterList, lastSupervision);
  }

  db_resultsFilterBy(columns: any[], groupby: string, filterList?: IFilterItemCollection[], lastSupervision = true): Observable<any[]> {
    let f = {} as any;
    f.columns = columns;
    f.groupby = groupby;
    this.configFilter(f, filterList);

    let filterJson = JSON.stringify(f);
    //console.log("db_resultsFilterBy filterJson: ", filterJson);


    if (lastSupervision) {
      let url = `${this.apiurlbase}/results/filter`;
      return this.http.post<IDB_Chart_Res[]>(url, filterJson, AppConfig.httpOptions).pipe(
        //tap(result => console.log("db_resultsFilterBy", result)),
        map(res => this.convertResultToNumber(res)),
        catchError(this.errorcontrolservice.handleError<any>('db_resultsFilterBy'))
      );
    }
    else {
      let url = `${this.apiurlbase}/supervisions/123/results`;
      return this.http.post<IDB_Chart_Res[]>(url, filterJson, AppConfig.httpOptions).pipe(
        //tap(result => console.log("db_resultsFilterBy", result)),
        map(res => this.convertResultToNumber(res)),
        catchError(this.errorcontrolservice.handleError<any>('db_resultsFilterBy'))
      );
    }

  }



  private configFilter(fJson: any, filterList?: IFilterItemCollection[]) {
    if (filterList) {
      fJson.filter = "";
      let sw = "";
      for (let whereby of filterList) {
        let whereValues = "";
        let sep = "";
        for (let wvalue of whereby.items) {
          whereValues += sep + "'" + wvalue.id + "'";
          sep = ",";
        }
        fJson.filter += sw + " " + whereby.id_filter + " IN (" + whereValues + ") ";
        sw = " AND ";
      }
    }
  }

  convertResultToNumber(source: any[]) {
    try {
      if (!source) {
        return;
      }
      for (let item of source) {
        item.count = +(item.count);
      }
      return source;
    } catch (err) {
      console.log(err);
    }

  }


  configTotals(sites): any {
    let total = { totalsites: 0, totalpower: 0, totalmodules: 0, totalpowerlost: 0,totalpowerlostpercent: 0, totalmodulesinactive: 0, totalmodulesinactivepercent: 0 };
    total.totalsites = sites.length;
    for (let x = 0; x < sites.length; x++) {
      let site: Site = sites[x];
      let siteStats = DashboardService.calculateSiteStats(site);
      total.totalpower += +siteStats.power;
      total.totalmodules += +siteStats.modules;
      total.totalmodulesinactive += +siteStats.modulesinactive;
      total.totalpowerlost += +siteStats.powerlost;

    }
    //total.totalpowerlost = total.totalpowerlost;//data is in watts
    //totalpowerlost is in watts
    total.totalpowerlostpercent = ((total.totalpowerlost/1000000)/total.totalpower)*100;
    total.totalmodulesinactivepercent = (total.totalmodulesinactive/total.totalmodules)*100;
    console.log("percente:" + total.totalpowerlost + " " + total.totalpower);
    return total;
  }


  static calculateSiteStats(site: Site) {
    let stats = { power: 0, modules: 0, powerlost: 0, modulesinactive: 0 };
    if (site.info.power) {
      stats.power += +site.info.power;
      stats.modules += site.info.modules ? site.info.modules : 0;
      let damagedModules = 0;
      if (site.info.lastSupervisionSummary && site.info.lastSupervisionSummary.damagedModules) {
        stats.modulesinactive = site.info.lastSupervisionSummary.damagedModules;
        stats.powerlost = +site.info.lastSupervisionSummary.powerLost;
      }

    }
    return stats;
  }
}
